/* eslint-disable */ 
var _ = require("lodash");
var moment = require("moment");

module.exports = class PriceCalculator{

  static getFinalPriceForEvent(purshaseProducts, eventInfo, cupom) {  
      let products = _.map(purshaseProducts, purchaseProduct => purchaseProduct.product);
      var price = this.getPrice(products);
      var discounts = this.getDiscounts(purshaseProducts,eventInfo.discounts,eventInfo.memberDiscounts,eventInfo.teamDiscounts)
      var memberProducts = this.getMemberProducts(purshaseProducts)
      return this.getFinalPrice( price, discounts, memberProducts, cupom)
  }
  
  
  static getPrice(products) {
    var total = 0;
    _.each(products, product => {
      total += product.currentPrice;
    });
    return total.toFixed(2);
  }

  static getFinalPrice(total, discounts, memberProducts = [], cupom) {
    total = parseFloat(total)
    _.each(discounts, discount => {
      total -= discount.discountValue;
    });
    _.each(memberProducts, memberProduct => {
      total += memberProduct.price;
    });

    if(cupom){
      if(cupom.isPercent){
        total = total - (cupom.discount/100)*total
      }else{
        total = total - cupom.discount
      }

    }

    if (total < 0) total = 0;
    return total.toFixed(2);
  }

  static getTotalDiscount(purshaseProducts, eventInfo)  {
    var total = 0;
    var discounts = this.getDiscounts(purshaseProducts,eventInfo.discounts,eventInfo.memberDiscounts, eventInfo.teamDiscounts)
    _.each(discounts, discount=>{
        total += parseFloat(discount.discountValue)
    })
    

    if (total < 0) total = 0;
    return total;
  }

  static getDiscountInfo(purshaseProducts, eventInfo)  {
    var total = 0;
    var discounts = this.getDiscounts(purshaseProducts,eventInfo.discounts,eventInfo.memberDiscounts, eventInfo.teamDiscounts)
    
    let discountsApplied = {}
    //   memberDiscounts:[],
    //   teamDiscounts:[],
    //   discounts:[]
    // }
    _.each(discounts, discount=>{
      const type = discount.constructor.name;
      if(!discountsApplied[type]){
        discountsApplied[type] = []
      }
      discountsApplied[type].push(discount.__data)
    })
    return discountsApplied
  }




  static getMemberProducts( purchaseProducts ) {

          let memberProducts = [];

         //loop in each product
         for (let ii = 0; ii < purchaseProducts.length; ii++) {
          const product = purchaseProducts[ii].product;
          
          //check for members in this products
          for (let iii = 0; iii < purchaseProducts[ii].members.length; iii++) {
            const member = purchaseProducts[ii].members[iii];
            const memberQuestions = product.memberInfos;
            
            //find type with product
            let productQuestions = _.filter(memberQuestions,{type:'product'});

            //for each selected type with price

            for (let iiii = 0; iiii < productQuestions.length; iiii++) {
              const questionProduct = productQuestions[iiii];
              let questionKey = questionProduct.key;
              let questionName = questionProduct.name;
              let questionOptions = questionProduct.options;
              //get the selected value
              let value = _.get(member, "infos." + questionKey)
              if(!_.isEmpty(value)){
                //get the price of value selected
                let option = _.find(questionOptions,{value:value})
                let price = parseFloat(_.get(option,'price',0))
                if( price > 0) {
                  memberProducts.push({name:questionName+' - '+option.name, price:price })
                }
              }
            }
            }
          }

          return memberProducts;
  }



static ruleAppliesForValue(rule, question,value){
  let key = rule[0];
  let compare = rule[1];
  let ruleValue = rule[2];
  let isInRule = false;
  let type = question.type;
  if (type == "age") {
    let infoVal = Math.abs(moment(value).diff(moment(), "years"));
    if (compare == "gte") {
      isInRule = (infoVal >= ruleValue);
    }
  }else{
    let infoVal = value;
    if (compare == "gte") {
      isInRule = (infoVal >= ruleValue);
    }else  if (compare == "eq") {
      isInRule = (infoVal == ruleValue);
    }else  if (compare < "lte") {
      isInRule = (infoVal < ruleValue);
    }
  }
  return isInRule;
}


  static getDiscounts( purchaseProducts, comboDiscountRules, memberDiscountRules, teamDiscountRules ) {
    let discounts = [];
    let productsIds = _.map(purchaseProducts, purchaseProduct => purchaseProduct.productId);
    let products = _.map(purchaseProducts, purchaseProduct => purchaseProduct.product);
    let price = this.getPrice(products);

    for (let i = 0; i < comboDiscountRules.length; i++) {
      const discount = comboDiscountRules[i];
      let productsToConsider = [];
      // console.log("products to ignore %o",discount.productsToIgnore);
      if(discount.productsToIgnore){
         _.each(products, product=>{
            let exist = _.includes( discount.productsToIgnore,product.id )
            if( !exist){
              productsToConsider.push(product)
            }
         })
      }else{
        productsToConsider = products
      }

      let price = this.getPrice(productsToConsider);

      let discountValue = discount.discount;
      if (discount.isPercent) {
        discountValue = (price * discountValue) / 100;
      }
      discount.discountValue = discountValue;

      //if minProduct Type discount
      if (discount.minProducts) {
        //LETODO IMPORTANT - if percentual,
        // give discount to the mimProducts price, not total
        if (discount.canAccumulate) {
          var totalAcummulate = Math.floor(
            products.length / discount.minProducts
          );
          for (let i = 0; i < totalAcummulate; i++) {
            discounts.push(discount);
          }
        } else if (discount.minProducts <= products.length) {
          discounts.push(discount);
        }
      
      //if combo Type discount
      } else if (discount.productCombo) {
        
        //this process bellow

        //else if just a regular discount without rule
      } else {
          if(discount.discountValue > 0)
              discounts.push({ ...discount });
      }
    }


    //COMBO Discounts Type
    let combosDiscounts = _.filter(comboDiscountRules,discount=> discount.productCombo )

    //sort from big to smaller
    combosDiscounts = _.sortBy(combosDiscounts,discount=>discount.productCombo.length).reverse()
    let productsIdsTemp = [...productsIds]
    let productsIdsFoundIndex = []

    _.each(combosDiscounts,discount=>{

      productsIdsFoundIndex = []
      let leftProducts = [...discount.productCombo];
      let foundCount = 0;

      for (let ii = 0; ii < leftProducts.length; ii++) {

            for (let i = 0; i < productsIdsTemp.length; i++) {
                const productId = productsIdsTemp[i];
                if (leftProducts[ii] == productId) {
                  foundCount++
                  productsIdsFoundIndex.push(i);
                  break;
                }
            }

            if(foundCount == leftProducts.length){
              if (discount.isPercent) {
                var totalProductInCombo = 0;
                _.each(discount.productCombo, productId => {
                  totalProductInCombo += _.find( products, product => product.productId == productId ).price;
                });
                discount.discountValue = (totalProductInCombo * discount.discount) / 100;
              }
              discounts.push(discount);
            
              // productsIdsFoundIndex = [...productsIdsFoundIndexTemp,...productsIdsFoundIndex];
              // productsIdsFoundIndexTemp = [];

              productsIdsFoundIndex = _.sortBy(productsIdsFoundIndex).reverse()
              for (let ii = 0; ii < productsIdsFoundIndex.length; ii++) {
                const foundIndex = productsIdsFoundIndex[ii];
                productsIdsTemp.splice(foundIndex, 1);
              }
              productsIdsFoundIndex = []

              if (discount.canAccumulate) {
                foundCount = 0;
                ii = -1
              } else {
                break;
              }

            }
      }

    })




    //If any of discounts has ignore others,
    //i will retorn only the discount with big values ??
    let discountWithIgnores = _.filter( discounts, dis => dis.ignoreOthers == true );
    if (discountWithIgnores) {
      var lateDiscountValue = 0;
      var biggestDiscount;
      for (let i = 0; i < discountWithIgnores.length; i++) {
        const discount = discountWithIgnores[i];
        let discountValue = discount.discountValue;
        if (discountValue > lateDiscountValue) {
          biggestDiscount = discount;
          lateDiscountValue = discountValue;
          discounts = [biggestDiscount];
        }
      }
    }



    let teamDiscounts = []
     //Now for team discounts
     for (let i = 0; i < teamDiscountRules.length; i++) {
        const discount = teamDiscountRules[i];
        //loop in each product
        for (let ii = 0; ii < purchaseProducts.length; ii++) {
            const product = purchaseProducts[ii].product;
            const productPrice = product.price;
            const size = _.get(product,'teamDefinitions.size',1);
            const pricePerMember = productPrice / size;
            const teamQuestions = product.teamInfos;
            let key = discount.rule[0];
            let compare = discount.rule[1];
            let ruleValue = discount.rule[2];
            let question = _.find(teamQuestions, mq => mq.key == key);
  

            let teams = purchaseProducts[ii].team[0]

            if (question && _.has(teams, "infos." + key)) {
              let infoVal = _.get(teams, "infos." + key)
              let isInRule = false;
              if (compare == "gte") {
                isInRule = (infoVal >= ruleValue);
              }else  if (compare == "eq") {
                isInRule = (infoVal == ruleValue);
              }else  if (compare < "lte") {
                isInRule = (infoVal < ruleValue);
              }

              if(isInRule) {
                if(discount.discountPerMember){
                  if (discount.isPercent) {
                    discount.discountValue =  ((pricePerMember * discount.discountPerMember) / 100) * size
                  }else{
                    discount.discountValue = discount.discountPerMember*size
                  }
                }else{
                  if (discount.isPercent) {
                    discount.discountValue = (productPrice * discount.discount) / 100;
                   } else {
                      discount.discountValue = discount.discount;
                    }
                }
                
                teamDiscounts.push(discount);

             }

            }
          }
        }




    let membersDiscounts = []

    //Now for member discounts and members selected products
    for (let i = 0; i < memberDiscountRules.length; i++) {

      const discount = memberDiscountRules[i];

      //loop in each product
      for (let ii = 0; ii < purchaseProducts.length; ii++) {
        const product = purchaseProducts[ii].product;
        const productPrice = product.price;
        const size = _.get(product,'teamDefinitions.size',1);
        const pricePerMember = productPrice / size;

        //check for members in this products
        for (let iii = 0; iii < purchaseProducts[ii].members.length; iii++) {

          const member = purchaseProducts[ii].members[iii];
          const memberQuestions = product.memberInfos;
       
          let key = discount.rule[0];
          let compare = discount.rule[1];
          let ruleValue = discount.rule[2];
          //check if question key exist
          let question = _.find(memberQuestions, mq => mq.key == key);

          if (question && _.has(member, "infos." + key)) {
            //!!!!!! LETODO IMPORTANT - make work for other filds cases etc
            const type = question.type;
            let infoVal = _.get(member, "infos." + key);

            let isInRule = false;
            if (type == "age") {
              infoVal = Math.abs(moment(infoVal).diff(moment(), "years"));
              if (compare == "gte") {
                isInRule = (infoVal >= ruleValue);
              }
            }else{
              if (compare == "gte") {
                isInRule = (infoVal >= ruleValue);
              }else  if (compare == "eq") {
                isInRule = (infoVal == ruleValue);
              }else  if (compare < "lte") {
                isInRule = (infoVal < ruleValue);
              }
            }

            if(isInRule) {
              if (discount.isPercent) {
                discount.discountValue =
                  (pricePerMember * discount.discount) / 100;
              } else {
                discount.discountValue = discount.discount;
              }
              membersDiscounts.push(discount);
            }


          }
        }
      }
    }





    let MembersDiscountWithIgnores = _.filter( membersDiscounts, dis => dis.ignoreOthers == true );
    if (MembersDiscountWithIgnores) {
      let lateDiscountValue = 0;
      let biggestDiscount;
      for (let i = 0; i < MembersDiscountWithIgnores.length; i++) {
        const discount = MembersDiscountWithIgnores[i];
        let discountValue = discount.discountValue;
        if (discountValue > lateDiscountValue) {
          biggestDiscount = discount;
          lateDiscountValue = discountValue;
          membersDiscounts = [biggestDiscount];
        }
      }
    }


    let finalDiscounts = _.omitBy(_.omitBy( _.concat(membersDiscounts,teamDiscounts,discounts), _.isNil), _.isUndefined);

    return _.map(finalDiscounts, discount=>{
        discount.discountValue = parseFloat(discount.discountValue).toFixed(2);
        return discount;
    })
  }
}
